module.exports = __webpack_public_path__ + "media/images/country_flags/mw-30408e89795c5a824e0b1e4a500d0c83.png";